import { useEffect, useState } from "react";
import CrudPage from "@/components/CrudPage";
import { api } from "@/lib/api";

export default function Anuncios() {
  const [ipbxs, setIpbxs] = useState([]);
  const [dids, setDids] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/ipbxs"), api.get("/dids")])
      .then(([i, d]) => { setIpbxs(i.data); setDids(d.data); })
      .catch(() => { setIpbxs([]); setDids([]); });
  }, []);
  const ipbxMap = Object.fromEntries(ipbxs.map(i => [i.id, i.nome]));

  return (
    <CrudPage
      title="Anúncios"
      subtitle="Mensagem, desvio para IPBX ou negação da chamada"
      endpoint="/anuncios"
      testidPrefix="anuncios"
      headers={["Nome", "Mensagem", "Ação", "IPBX", "DID", "Status"]}
      renderRow={(r) => (
        <>
          <td className="font-medium">{r.nome}</td>
          <td className="max-w-[360px] truncate text-[color:var(--text-secondary)]">{r.mensagem}</td>
          <td>{r.acao === "negar" ? <span className="sbc-tag tag-offline">negar</span> : <span className="sbc-tag tag-online">encaminhar</span>}</td>
          <td>{ipbxMap[r.ipbx_id] || <span className="text-[color:var(--text-muted)]">rota/IPBX padrão</span>}</td>
          <td className="font-mono text-xs">{r.did_saida || "-"}</td>
          <td>{r.enabled ? <span className="sbc-tag tag-online">ativo</span> : <span className="sbc-tag tag-offline">inativo</span>}</td>
        </>
      )}
      defaultValues={{ nome: "", mensagem: "", audio_path: "", acao: "encaminhar", ipbx_id: "", did_saida: "", hangup_cause: "CALL_REJECTED", enabled: true }}
      fields={[
        { key: "nome", label: "Nome", full: true, placeholder: "Ex: Aviso de gravação" },
        { key: "mensagem", label: "Mensagem do anúncio", type: "textarea", full: true, placeholder: "Sua ligação será encaminhada para atendimento.", hint: "Se audio_path ficar vazio, o dialplan tenta falar este texto via TTS do Voxyra SBC." },
        { key: "audio_upload", label: "Upload de áudio WAV/MP3", type: "file", full: true, accept: ".wav,.wave,.mp3,audio/wav,audio/mpeg", uploadEndpoint: "/anuncios/upload-audio", targetKey: "audio_path", hint: "Ao enviar, o caminho abaixo é preenchido automaticamente." },
        { key: "audio_path", label: "Arquivo de áudio no Voxyra SBC", mono: true, full: true, placeholder: "/var/lib/sbc-voxyra/anuncios/aviso.wav", hint: "Pode preencher manualmente se o arquivo já existir no servidor." },
        { key: "acao", label: "Depois do anúncio", type: "select", options: [
          { value: "encaminhar", label: "Desviar/encaminhar para IPBX" },
          { value: "negar", label: "Negar/desligar chamada" },
        ]},
        { key: "ipbx_id", label: "Desviar para IPBX", type: "select", options: [
          { value: "", label: "Usar IPBX da rota" }, ...ipbxs.map(i => ({ value: i.id, label: i.nome }))
        ]},
        { key: "did_saida", label: "DID enviado ao IPBX", type: "select", options: [{ value: "", label: "Sem DID especifico" }, ...dids.filter(d => d.enabled !== false).map(d => ({ value: d.numero, label: d.numero }))] },
        { key: "hangup_cause", label: "Motivo ao negar", mono: true, placeholder: "CALL_REJECTED" },
        { key: "enabled", label: "Ativo", type: "toggle" },
      ]}
    />
  );
}
